import React, { useEffect, useRef, useState } from "react";
import "./App.css";
import Header from "./components/header/Header";
import FolioDeVenta from "./components/screens/folio-de-venta/FolioDeVenta";
import { Box } from "@mui/material";
import Resultado from "./components/screens/resultado/Resultado";
import DatosCliente from "./components/screens/datos-clientes/DatosCliente";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import CorreoElectronico from "./components/screens/correo-electronico/CorreoElectronico";
import { StepsProvider } from "./contexts/steps-controller";

function App() {
  const [isActive, setIsActive] = useState(1);
  const [height, setHeight] = useState(0);
  const [datosCompra, setDatosCompra] = useState([]);

  let folioDeVentaRef = useRef(null);
  let datosClienteRef = useRef(null);
  let correoRef = useRef(null);
  let resultadoRef = useRef(null);

  useEffect(() => {
    let height = 0;
    switch (isActive) {
      case 1:
        height = folioDeVentaRef.current.clientHeight;
        break;
      case 2:
        height = datosClienteRef.current.clientHeight;
        break;
      case 3:
        height = correoRef.current.clientHeight;
        break;
      case 4:
        height = resultadoRef.current.clientHeight;
        break;
      default:
        throw new Error(`No existe la pantalla ${isActive}}`);
    }
    //Le agregamos un tamaño extra para evitar que se oculten los botones de siguiente y volver
    height += 35;
    setHeight(height);
  }, [isActive]);

  const nextStep = () => {
    setIsActive(isActive + 1);
  };

  const prevStep = () => {
    setIsActive(isActive - 1);
  };

  const fadeInRight = {
    from: { opacity: 0, x: 100 },
    to: { opacity: 1, x: 0 },
  };
  const fadeOutLeft = {
    from: { opacity: 1, x: 0 },
    to: { opacity: 0, x: -100 },
  };

  const showToast = ({ type, message, onClickCallback, canTryAgain }) => {
    switch (type) {
      case "success":
        toast.success(message, {
          icon: "✅",
        });
        break;
      case "error":
        toast.error(message, {
          icon: "❌",
          onClick: onClickCallback ? onClickCallback : null,
        });
        break;

      default:
        toast(message);
        break;
    }
  };

  const propsShared = {
    isActive,
    nextStep,
    prevStep,
    fadeInRight,
    fadeOutLeft,
    setHeight,
    showToast,
    setDatosCompra,
  };

  return (
    <div className="container">
      <StepsProvider>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            height: "100%",
          }}
          >
          <div className="containerHeader">
            <Header {...propsShared} />
          </div>
          <Box
            sx={{
              display: "flex",
              justifyContent: "start",
              alignItems: "center",
              p: 1,
              m: "auto",
              borderRadius: 1,
              height: "100%",
            }}
          >
            <Box
              style={{
                display: "flex",
                transition: "height 0.5s",
                height,
                overflow: "hidden",
                padding: isActive === 4 ? "0 50px" : "",
              }}
              className="containerScreen"
            >
              <FolioDeVenta
                ref={folioDeVentaRef}
                hidden={isActive !== 1}
                {...propsShared}
              />
              <DatosCliente
                ref={datosClienteRef}
                hidden={isActive !== 2}
                datosCompra={datosCompra}
                {...propsShared}
              />
              <CorreoElectronico
                ref={correoRef}
                hidden={isActive !== 3}
                {...propsShared}
              />
              <Resultado
                ref={resultadoRef}
                hidden={isActive !== 4}
                setIsActive={setIsActive}
                {...propsShared}
              />
            </Box>
          </Box>
        </Box>
      </StepsProvider>
      <ToastContainer />
    </div>
  );
}

export default App;
